export const NAVIGATION_SET_DESKTOP = 'NAVIGATION_SET_DESKTOP';
export const NAVIGATION_SET_MOBILE = 'NAVIGATION_SET_MOBILE';
